import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CMASummaryTableDataValuesDifference from './CMASummaryTableDataValuesDifference';
import { CMASummaryFilters } from './types';
import { parseCMASummaryFeeData } from './utils';

const Title = styled.div`
  font-family: var(--font-regular);
  font-size: 14px;
`;

type Props = {
  feeLevel: number;
  dataTestId?: string;
};

const CMASummaryTableDataFees = ({ feeLevel, dataTestId }: Props) => {
  const { viewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;
  const [feeLevelValue, feeLevelDifference] = parseCMASummaryFeeData(feeLevel, filters?.viewOptions?.valueDisplay);

  return (
    <div data-test-id={dataTestId}>
      {typeof feeLevelValue == 'number' && (
        <Title>
          ${feeLevelValue.toLocaleString()} <CMASummaryTableDataValuesDifference difference={feeLevelDifference} />
        </Title>
      )}
      {typeof feeLevelValue != 'number' && '-'}
    </div>
  );
};

export default CMASummaryTableDataFees;
